module.exports = __webpack_public_path__ + "img/sbp.7f2fcbce.svg";